import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "keyword-popular" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "인기 키워드"),
  /*#__PURE__*/_createElementVNode("p", { class: "page-desc" }, [
    /*#__PURE__*/_createTextVNode(" 주제를 고르면 그 분야에서 "),
    /*#__PURE__*/_createElementVNode("strong", null, "많이 검색되는 키워드"),
    /*#__PURE__*/_createTextVNode("를 순위로 보여줍니다. 글감을 정하지 못했을 때 여기서 시작하세요. ")
  ])
], -1)
const _hoisted_3 = { class: "source-toggle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("em", null, "구글", -1)
const _hoisted_5 = { class: "search-card" }
const _hoisted_6 = { class: "topic-chips" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "seed-row" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mode-toggle" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mt-note" }, [
  /*#__PURE__*/_createTextVNode(" 주제를 되풀이하는 말(근처맛집·식당·카페)은 빼고 "),
  /*#__PURE__*/_createElementVNode("b", null, "구체적인 글감"),
  /*#__PURE__*/_createTextVNode("만 보여 줍니다. "),
  /*#__PURE__*/_createElementVNode("b", null, "지금 뜨는 것"),
  /*#__PURE__*/_createTextVNode("을 보려면 급상승순으로. ")
], -1)
const _hoisted_14 = {
  key: 0,
  class: "notice notice-error"
}
const _hoisted_15 = {
  key: 1,
  class: "skeleton-card"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "result-summary" }
const _hoisted_18 = { class: "chip" }
const _hoisted_19 = { class: "chip" }
const _hoisted_20 = { class: "chip" }
const _hoisted_21 = { class: "notice notice-muted" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("b", null, "인기 검색어 목록 API를 제공하지 않습니다", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("b", null, "최근 4주 평균 ÷ 그 이전 평균", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("b", null, "월간 검색량순", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("b", null, "주제를 되풀이하는 말은 뺐습니다", -1)
const _hoisted_26 = { class: "rank-list" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "rk-vol" }
const _hoisted_29 = { class: "rk-device" }
const _hoisted_30 = { class: "rk-share" }
const _hoisted_31 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_32 = { class: "search-card" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "notice notice-muted rt-intro" }, [
  /*#__PURE__*/_createElementVNode("b", null, "구글에서 지금 뜨는 검색어"),
  /*#__PURE__*/_createTextVNode("입니다(한국). 네이버가 실시간 검색어를 폐지해(2021) 그 공백을 메웁니다. "),
  /*#__PURE__*/_createElementVNode("b", null, "구글 트렌드라 네이버와 결이 다릅니다"),
  /*#__PURE__*/_createTextVNode(" — 시사·연예·스포츠 이슈 위주라, 「지금 뭐가 터졌나」 신호로 쓰세요. 카테고리는 "),
  /*#__PURE__*/_createElementVNode("b", null, "자동 분류"),
  /*#__PURE__*/_createTextVNode("라 일부 어긋날 수 있습니다. 항목을 누르면 네이버 검색량·포화도로 넘어갑니다. ")
], -1)
const _hoisted_34 = {
  key: 0,
  class: "topic-chips"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  class: "notice notice-error"
}
const _hoisted_37 = {
  key: 1,
  class: "skeleton-card"
}
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "result-summary" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "chip" }, [
  /*#__PURE__*/_createTextVNode("출처 "),
  /*#__PURE__*/_createElementVNode("b", null, "구글 트렌드 · 한국")
], -1)
const _hoisted_41 = { class: "chip" }
const _hoisted_42 = {
  key: 0,
  class: "chip"
}
const _hoisted_43 = { class: "rank-list rt-list" }
const _hoisted_44 = { class: "rt-main" }
const _hoisted_45 = { class: "rt-top" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "rt-cat" }
const _hoisted_48 = {
  key: 0,
  class: "rt-traffic"
}
const _hoisted_49 = {
  key: 1,
  class: "rt-naver"
}
const _hoisted_50 = {
  key: 2,
  class: "rt-naver dim"
}
const _hoisted_51 = ["href"]
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 3,
  class: "empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: _normalizeClass(["src-btn", { active: _ctx.source === 'naver' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSource('naver')))
      }, " 네이버 인기 ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["src-btn", { active: _ctx.source === 'realtime' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSource('realtime')))
      }, [
        _createTextVNode(" 실시간 트렌드 "),
        _hoisted_4
      ], 2)
    ]),
    (_ctx.source === 'naver')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (t) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: t,
                  class: _normalizeClass(["chip-btn", { active: _ctx.seed === t }]),
                  onClick: ($event: any) => (_ctx.pick(t))
                }, _toDisplayString(t), 11, _hoisted_7))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.seed) = $event)),
                class: "seed-input",
                type: "text",
                placeholder: "직접 입력 (예: 캠핑)",
                maxlength: "100",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.seed]
              ]),
              _createElementVNode("button", {
                class: "btn-search",
                disabled: _ctx.loading,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
              }, _toDisplayString(_ctx.loading ? "조회 중…" : "순위 보기"), 9, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: _normalizeClass(["mt-btn", { active: !_ctx.rising }]),
                disabled: _ctx.loading,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setMode(false)))
              }, " 검색량순 ", 10, _hoisted_11),
              _createElementVNode("button", {
                class: _normalizeClass(["mt-btn", { active: _ctx.rising }]),
                disabled: _ctx.loading,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setMode(true)))
              }, " 급상승순 ", 10, _hoisted_12),
              _hoisted_13
            ])
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, "인기 키워드를 불러오는 중…"))
            : (_ctx.result)
              ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createTextVNode("주제 "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.result.seed), 1)
                    ]),
                    _createElementVNode("span", _hoisted_19, [
                      _createTextVNode("연관 키워드 "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.result.totalRelated.toLocaleString()), 1)
                    ]),
                    _createElementVNode("span", _hoisted_20, [
                      _createTextVNode("표시 "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.result.rows.length), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createTextVNode(" 네이버는 "),
                    _hoisted_22,
                    _createTextVNode("(실시간 검색어는 2021년 폐지). "),
                    (_ctx.rising)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" 이 순위는 "),
                          _hoisted_23,
                          _createTextVNode("으로 계산한 급상승률입니다. 검색량 상위 25개를 후보로 잡아 데이터랩으로 추이를 비교했습니다. ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" 이 순위는 연관 키워드를 "),
                          _hoisted_24,
                          _createTextVNode("으로 정렬한 것입니다. 다만 "),
                          _hoisted_25,
                          _createTextVNode(" — 「맛집」에서 근처맛집·주변맛집·강남맛집·식당·카페처럼 다시 「맛집」을 말하는 것은 글감이 되지 못하면서 검색량만 커서 위를 다 차지했습니다. ")
                        ], 64)),
                    _createTextVNode(" 속도를 위해 발행량·포화도는 조회하지 않습니다 — 키워드를 누르면 상세 분석으로 넘어갑니다. ")
                  ]),
                  _createElementVNode("ol", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result.rows, (row, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: row.keyword,
                        class: "rank-item"
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["rk-no", _ctx.rankClass(i)])
                        }, _toDisplayString(i + 1), 3),
                        _createElementVNode("a", {
                          class: "rk-kw",
                          href: "#",
                          onClick: _withModifiers(($event: any) => (_ctx.analyze(row.keyword)), ["prevent"])
                        }, _toDisplayString(row.keyword), 9, _hoisted_27),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(row.totalVolume.toLocaleString()), 1),
                        _createElementVNode("span", _hoisted_29, [
                          _createElementVNode("i", {
                            class: "rk-mo",
                            style: _normalizeStyle({ width: _ctx.mobileShare(row) + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_30, "모바일 " + _toDisplayString(_ctx.mobileShare(row)) + "%", 1),
                        (_ctx.rising)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass(["rk-growth", _ctx.growthClass(row.growth)])
                            }, _toDisplayString(_ctx.growthLabel(row.growth)), 3))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["rk-comp", _ctx.compClass(row.competition)])
                            }, _toDisplayString(row.competition || "-"), 3))
                      ]))
                    }), 128))
                  ])
                ]))
              : (!_ctx.loading && !_ctx.errorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 주제를 고르거나 직접 입력해 보세요. "))
                : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_32, [
            _hoisted_33,
            (_ctx.rt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["chip-btn", { active: _ctx.rtCategory === 'all' }]),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.rtCategory = 'all'))
                  }, [
                    _createTextVNode(" 전체 "),
                    _createElementVNode("em", null, _toDisplayString(_ctx.rt.items.length), 1)
                  ], 2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rt.categories, (c) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: c.code,
                      class: _normalizeClass(["chip-btn", { active: _ctx.rtCategory === c.code }]),
                      onClick: ($event: any) => (_ctx.rtCategory = c.code)
                    }, [
                      _createTextVNode(_toDisplayString(c.label) + " ", 1),
                      _createElementVNode("em", null, _toDisplayString(c.count), 1)
                    ], 10, _hoisted_35))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.rtError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.rtError), 1))
            : _createCommentVNode("", true),
          (_ctx.rtLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, "실시간 트렌드를 불러오는 중…"))
            : (_ctx.rt && _ctx.rt.items.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, [
                      _createTextVNode("표시 "),
                      _createElementVNode("b", null, _toDisplayString(_ctx.filteredTrends.length), 1)
                    ]),
                    (!_ctx.rt.naverVolumeAvailable)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_42, "네이버 검색량 미조회"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("ol", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTrends, (row) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: row.rank,
                        class: "rank-item rt-item"
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["rk-no", _ctx.rankClass(row.rank - 1)])
                        }, _toDisplayString(row.rank), 3),
                        _createElementVNode("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("a", {
                              class: "rk-kw",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.analyze(row.keyword)), ["prevent"])
                            }, _toDisplayString(row.keyword), 9, _hoisted_46),
                            _createElementVNode("span", _hoisted_47, _toDisplayString(row.categoryLabel), 1),
                            (row.approxTraffic)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, "구글 " + _toDisplayString(row.approxTraffic), 1))
                              : _createCommentVNode("", true),
                            (row.naverVolume != null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, "네이버 월 " + _toDisplayString(row.naverVolume.toLocaleString()), 1))
                              : (_ctx.rt.naverVolumeAvailable)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "네이버 검색량 낮음"))
                                : _createCommentVNode("", true)
                          ]),
                          (row.newsTitle)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "rt-news",
                                href: row.newsUrl || '#',
                                target: "_blank",
                                rel: "noopener"
                              }, [
                                _createTextVNode(_toDisplayString(row.newsTitle), 1),
                                (row.newsSource)
                                  ? (_openBlock(), _createElementBlock("em", _hoisted_52, " · " + _toDisplayString(row.newsSource), 1))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_51))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (!_ctx.rtLoading && !_ctx.rtError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, " 실시간 트렌드를 가져오지 못했습니다. 잠시 후 다시 시도해 주세요. "))
                : _createCommentVNode("", true)
        ], 64))
  ]))
}